var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25031 3.67924L4.10818 7.82138C3.53627 8.39329 3.53627 9.32053 4.10818 9.89244C4.68009 10.4644 5.60734 10.4644 6.17924 9.89244L10.3214 5.75031C11.4652 4.60649 11.4652 2.752 10.3214 1.60818C9.17756 0.464359 7.32306 0.464359 6.17924 1.60818L2.03711 5.75031C0.321381 7.46604 0.321383 10.2478 2.03711 11.9635C3.75284 13.6792 6.53458 13.6792 8.25031 11.9635L12.3924 7.82138",
    stroke: "#A5B4CB",
    strokeWidth: 1.50063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.f42e59fb2b326ce0d9117d64c22aa0fe.svg";
export { ForwardRef as ReactComponent };